module.exports = __webpack_public_path__ + "media/images/skebi/icon-small_armchair-0f90725fbdba08ad9bacb63de06faf60.png";